import type { Category } from '@features/categories/types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import type { Property } from 'shared-types/Property';

import SpaTreatmentsCategoryContainer from './containers/container';
import { SpaTreatmentsCategoryV2 } from './v2';

type SpaTreatmentsCategoryVersionProps = {
  property: Property;
  language: string;
  category: Category;
};

export const SpaTreatmentsCategoryVersion: FC<SpaTreatmentsCategoryVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SpaTreatmentsCategoryV2 category={props.category} language={props.language} />;
  return (
    <SpaTreatmentsCategoryContainer
      categoryId={props.category.id}
      property={props.property}
      category={props.category}
      language={props.language}
    />
  );
};
